import axios from "axios";
import { AppConfig } from "./../../AppConfig.js";

const abacusCoreApiBaseUrl = AppConfig.abacusCoreApiBaseUrl;
export const instance = axios.create({
  baseURL: abacusCoreApiBaseUrl,
  // 5 minutes
  timeout: 300000,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "content-type": "application/json",
    Authorization: "ApiKey 75kY0sSlOILOlfLE6hQbFu57f2VA1JirTEy79Thy"
  }
});
